import getDocumentCookie from './getDocumentCookie';

export default function parseCookie(cookieName: string, cookie?: string): any | null {
  const cookieString = cookie || getDocumentCookie();

  const cookies: string[] = cookieString.split(';');
  let parsedValue = null;

  cookies.some((cookie) => {
    const c = cookie.trim();
    const matcher = `${cookieName}=`;
    if (c.indexOf(matcher) === 0) {
      try {
        parsedValue = JSON.parse(c.substring(matcher.length, c.length));
        return true;
      } catch (e) {
        // If JSON parsing fails, just move on gracefully.
        return false;
      }
    }

    return false;
  });

  return parsedValue;
}
